import { Outlet } from '@tanstack/react-router';
import { Sidebar } from './Sidebar';
import { useUIStore } from '@/stores/ui.store';

/**
 * Authenticated shell — Sidebar (fixed) + scrollable main area.
 * Page-level TopBanner is mounted per-route so each page controls
 * its title, search placeholder, etc.
 *
 * 2026-09-19: en celular y tablet (<lg) la barra lateral pasa a ser un cajón
 * que se abre con el botón del encabezado; antes ocupaba 256 px fijos y en un
 * teléfono de 390 px dejaba el contenido en una columna ilegible. En escritorio
 * (>=lg) no cambia nada.
 */
export function Layout() {
  const menuAbierto = useUIStore((s) => s.mobileMenuOpen);
  const setMenu = useUIStore((s) => s.setMobileMenu);

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <Sidebar />
      {menuAbierto && (
        <div
          className="fixed inset-0 z-40 bg-black/50 lg:hidden"
          onClick={() => setMenu(false)}
          aria-hidden="true"
        />
      )}
      <main className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <Outlet />
      </main>
    </div>
  );
}
